import { Component, OnInit } from '@angular/core';
import * as FileSaver from 'file-saver';
import { DepartmentDto } from 'src/app/models/DepartmentDto';
import { LocationDto } from 'src/app/models/LocationDto';
import { movementapprovalDto } from 'src/app/models/movementapprovalDto';
import { MovementDto } from 'src/app/models/MovementDto';
import { NotificationType } from 'src/app/models/notification.message';
import { Profile } from 'src/app/models/profile';
import { DateRangeRequest } from 'src/app/models/requests/DateRangeRequest';
import { MovementJDDto } from 'src/app/models/requests/MovementJDDto';
import { ContractsService } from 'src/app/services/contracts.service';
import { DepartmentsService } from 'src/app/services/departments.service';
import { LocationsService } from 'src/app/services/locations.service';
import { MovementService } from 'src/app/services/movement.service';
import { MovementapprovalService } from 'src/app/services/movementapproval.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';
import { UserService } from 'src/app/services/user.service';
import { VendorsService } from 'src/app/services/vendors.service';

@Component({
  selector: 'app-movement-reports',
  templateUrl: './movement-reports.component.html',
  styleUrls: ['./movement-reports.component.css']
})
export class MovementReportsComponent implements OnInit {

  constructor(private movementService: MovementService, private movementservice: MovementService,private locationService: LocationsService,private contractService:ContractsService, private notification: NotificationService,
    private vendorService: VendorsService, private movementApprovalService: MovementapprovalService, private departmentService: DepartmentsService,
    private tokenService: TokenService,private userServis: UserService ) { }

  ngOnInit(): void {
    this.loadRecords();
  }
  date:Date[] = [];
  Requests: MovementDto[] = [];
  canPrint: boolean = false;
  ViewManPowerVisible = false;
  ViewRequestVisible = false;
  ApproveRequest: MovementDto | any
  Departments: DepartmentDto[] = [];
  Locations: LocationDto[] | undefined;
  RequestApprovals: movementapprovalDto[] | undefined;
  UpdateRequest: any;
  MovementJD: MovementJDDto[] | undefined;
  selectedDepartmentId: number = 0;
  selectedDestinationLocationId:string ='';
  selectedInitialLocationId:string ='';
  selectedDestinationFunctionId:string ='';
  selectedCurrentFunctionId:string ='';
  pdf:string="";
  receivedfile: string = "";
  selectedUserEmail:string ='';
  selectedStatus:string ='';
  Statuses:any[]=[];
  Users :Profile[]=[];

  async loadRecords() {
     
    let resRequests = await this.movementservice.getMovement().toPromise();
    this.Requests = <MovementDto[]>resRequests.responseData;
    let resDeparts = await this.departmentService.getDepartments().toPromise();
    this.Departments = <DepartmentDto[]>resDeparts.responseData;

    let resLocations = await this.locationService.getLocations().toPromise();
    this.Locations = <LocationDto[]>resLocations.responseData;

    let Users = await this.userServis.getUsers().toPromise();
    this.Users = <Profile[]>Users.responseData;
      this.getStatusData();


    try {
      this.Requests?.sort((n1,n2) => {
        if (n1.id > n2.id) {
            return -1;
        }
    
        return 0;
    });
    } catch (error) {
      
    }

  }
  async onEmpDestinationLocationChange(e: any){
  
    ;
    var obj:any = {}
    obj.reportParam = this.selectedDestinationLocationId;
   
   let resRequests = await this.movementservice.GetByempDestinationLocation( obj).toPromise();
   this.Requests = <MovementDto[]>resRequests.responseData;
   
     }
  async onEmpInitialLocationChange(e: any){
  
    var obj:any = {}
    obj.reportParam = this.selectedInitialLocationId;
   
    let resRequests = await this.movementservice.GetByempInitialLocation(obj).toPromise();
    this.Requests = <MovementDto[]>resRequests.responseData;
    
      }

  async onEmpDestinationFunctionChange(e: any){
    var obj:any = {}
    obj.reportParam = this.selectedDestinationFunctionId;
 
        let resRequests = await this.movementservice.GetByempDestinationFunction(obj).toPromise();
        this.Requests = <MovementDto[]>resRequests.responseData;
        
          }

   async onEmpCurrentFunctionChange(e: any){
    var obj:any = {}
    obj.reportParam = this.selectedCurrentFunctionId;
 
            let resRequests = await this.movementservice.GetByempCurrentFunction(obj).toPromise();
            this.Requests = <MovementDto[]>resRequests.responseData;
            
   }
  onChange(result: Date[]): void {
    
    console.log('onChange: ', result);
    ;
    this.date=result;
    var r1 = result[0];
    var r2 = this.date[0];


  }
 
  async onStatusChange(e: any)
  {
    var obj:any = {}
    obj.reportParam = this.selectedStatus;
    let resRequests = await this.movementservice.GetByStatus(obj).toPromise();
    this.Requests = <MovementDto[]>resRequests.responseData;

  }
  getStatusColor(status: string): string {
    switch (status) {
      case "New":
        return 'badge badge-warning';
      case "Pending":
        return 'badge badge-warning';
      case "Approved":
        return 'badge badge-success';
      case "Rejected":
        return 'badge badge-danger';
      default:
        return 'badge badge-info';
    }

  }

  
  async showDocument(datas: MovementDto){
    // this.open();
    ;
    let getJDRequest = await this.movementService.GetJDForRequest(datas.id).toPromise();
       ;
     
       this.MovementJD = <MovementJDDto[]>getJDRequest.responseData;
     
        this.receivedfile = getJDRequest.responseData[0].documentContent.replace("data:application/pdf;base64," , "")
        this.pdf = getJDRequest.responseData[0].documentContent
     
      //  this.PathReportString = 'data:application/pdf;base64,' + (this.sanitizer.bypassSecurityTrustResourceUrl(this.receivedfile) as any).changingThisBreaksApplicationSecurity;
              
       // top!.document.getElementById('ifrm')!.setAttribute("src", this.PathReportString)!;
       const pdfWindow = window.open("")!;    
       pdfWindow.document.write("<html<head><title>Additional Report</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>");    
       pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64, " +    
       encodeURI(this.receivedfile) + "#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>") 
   
   
   }

  
  close(): void {
    this.ViewRequestVisible = false;
  }

  
  async getJD(datas: MovementDto) {
    // this.ViewManPowerVisible = true;
 ;
     this.ApproveRequest = datas;
     let getJDRequest = await this.movementService.GetJDForRequest(datas.id).toPromise();
     ;
  
     this.MovementJD = <MovementJDDto[]>getJDRequest.responseData;
     var pdfFile = getJDRequest.responseData[0].documentContent;
     if(pdfFile.includes("data:application/pdf;base64")){
       var receivedfile = getJDRequest.responseData[0].documentContent.replace("data:application/pdf;base64," , "")

       const b = Uint8Array.from(atob(receivedfile), c => c.charCodeAt(0));
       const blob = new Blob([b] , {type: "application/octet-stream"});
       FileSaver.saveAs(blob, getJDRequest.responseData[0].documentName);
  
     }
   
   var receivedfile = getJDRequest.responseData[0].documentContent.replace("data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," , "")
   const b = Uint8Array.from(atob(receivedfile), c => c.charCodeAt(0));
   const blob = new Blob([b] , {type: "application/octet-stream"});
   FileSaver.saveAs(blob, getJDRequest.responseData[0].documentName);

  }
  


  async open(data: MovementDto) {
    ;
    this.ViewRequestVisible = true;

    let resApprovals = await this.movementApprovalService.getRequestApprovals(data.id).toPromise();
    this.RequestApprovals = <movementapprovalDto[]>resApprovals.responseData;

    this.UpdateRequest = data;


  //  if (data.status === "Approved") { this.canUpdate = true; this.canPrint = true }

    if (data.status === "Active") { this.canPrint = true }

  }

    getStatusData()
  {
   var statuses =  [{
  name:"New",
  value:"New"   } , {name:"Pending",  value:"Pending"  },  {  name:"Approved",   value:"Approved"  } ,{name:"Rejected",  value:"Rejected"},
  {name:"Active",  value:"Active"}, {name:"Completed",  value:"Completed"},{name:"Expired",  value:"Expired"},{name:"Pending_EA",  value:"Pending_EA"}, 
  {name:"Closed",  value:"Closed"}
  
  ];

  this.Statuses =statuses;
  

  }
  async GetByDate()
  {
    ;
   let  theDaStartDate:Date= this.date[0];
   var strtDt  =this.date[0];
   var endDt   =this.date[1];
   if (strtDt>endDt)
   {
    this.notification.sendMessage({
      message: "Start Date cannot be more than end date",
      type: NotificationType.success
    });
   }

   let VeeM :DateRangeRequest={
   startDate :strtDt,
   endDate:endDt
    
   };
    let resRequests = await this.movementservice.getByDateRange(VeeM).toPromise();
    this.Requests = <MovementDto[]>resRequests.responseData;
  //  this.Requests = <ContractDto[]>resRequests.responseData;

  }

  
  
  exportExcel() {
    if (this.Requests.length > 0) {
      import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.Requests);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "ExportExcel");
      });
    }
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
}
